import TagManager from 'react-gtm-module'

export const initializeTagManager = (): void => {
  const tagManagerArgs = {
    gtmId: 'G-M86RJL4TS4',
  }
  TagManager.initialize(tagManagerArgs)
}
